import gql from 'graphql-tag';
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { MutationFunction } from '@apollo/client';

import { bugsnag } from '../../../../../../utils/platform';
import { SetLastSeenAt } from './__generated__/SetLastSeenAt';

export const SET_LAST_SEEN_AT_MUTATION = gql`
    mutation SetLastSeenAt {
        setLastSeenAt {
            userId
        }
    }
`;
export const UNSEEN_CHAT_QUERY = gql`
    query GetUnseenChatCountQuery {
        unseenChatCount
    }
`;

export interface SetLastSeenAtMutationProps {
    children: (props: { setLastSeenAt: () => void }) => React.ReactElement;
}

export class SetLastSeenAtMutation extends React.Component<SetLastSeenAtMutationProps> {
    render() {
        return (
            <Mutation<SetLastSeenAt, {}> mutation={SET_LAST_SEEN_AT_MUTATION}>
                {(mutationFunction) => {
                    return this.props.children({
                        setLastSeenAt: () => this.mutate(mutationFunction),
                    });
                }}
            </Mutation>
        );
    }

    mutate(mutate: MutationFunction) {
        const options = { refetchQueries: [{ query: UNSEEN_CHAT_QUERY }] };
        mutate(options).catch(() => {
            bugsnag.notify('SetLastSeenAtMutationError', 'Error setting last seen at');
        });
    }
}

export default SetLastSeenAtMutation;
